import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const {
    t,
    lang,
    setLang
  } = useLanguage();
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <motion.nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-background/80 backdrop-blur-md py-4 shadow-lg' : 'bg-transparent py-6'}`} initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.8,
    ease: 'easeOut'
  }} data-id="element-149">
      <div className="container mx-auto px-6 flex justify-between items-center" data-id="element-150">
        <motion.div className="font-serif text-2xl font-bold text-primary tracking-widest cursor-pointer" whileHover={{
        scale: 1.05
      }} onClick={() => window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })} data-id="element-151">
          SOY JOHA
        </motion.div>

        <div className="flex items-center gap-6" data-id="element-152">
          {/* Language Switcher */}
          {lang && <div className="flex items-center gap-2 bg-black/40 backdrop-blur-sm border border-white/10 rounded-full p-1" data-id="element-153">
              <button onClick={() => setLang('es')} className={`w-8 h-8 rounded-full flex items-center justify-center text-sm transition-colors ${lang === 'es' ? 'bg-primary text-black' : 'text-gray-400 hover:text-white'}`} data-id="element-154">
                ES
              </button>
              <button onClick={() => setLang('en')} className={`w-8 h-8 rounded-full flex items-center justify-center text-sm transition-colors ${lang === 'en' ? 'bg-primary text-black' : 'text-gray-400 hover:text-white'}`} data-id="element-155">
                EN
              </button>
            </div>}

          <motion.button className="hidden md:block border border-primary text-primary px-6 py-2 rounded-full hover:bg-primary hover:text-background transition-colors duration-300 text-sm tracking-wider font-medium" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} onClick={() => document.getElementById('cta')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-156">
            {t('nav.contact')}
          </motion.button>
        </div>
      </div>
    </motion.nav>;
};